var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { getButtonLang, getValuesFromLocale } from "@payair/e-com-common-sdk/core/Helpers";
import { detect } from "detect-browser";
import { GooglePayButtonSizeModeEnumsObj } from "../enums/GooglePayButtonSizeModeEnum";
import { GooglePayEventTypeEnumsObj } from "../enums/GooglePayEventTypeEnum";
import { validateGooglePayButtonParams } from "../models/GooglePayButtonParams";
import { validateGooglePayInitParams } from "../models/GooglePayInitParams";
import { BUILD_TYPE, SDK_VERSION } from "../models/GooglePayVersion";
import notSupportedBrowsers from "../notSupportedBrowsers";
import EventReporter from "./eventReporter/EventReporter";
import GooglePaySdkService from "./GooglePaySdkService";
/** @internal */
var googlePaySdkService;
/** @internal */
var googlePayInitParamsGlobal;
/** @internal */
var eventReporter;
/** @internal */
var paymentsClient;
/** @internal */
var allowedPaymentMethods;
/** @internal */
var paymentDataRequest;
/** @internal */
var apiVersion = 2;
/** @internal */
var apiVersionMinor = 0;
/** @internal */
var GOOGLE_PAY_SDK_SCRIPT = "https://pay.google.com/gp/p/js/pay.js";
/** @internal */
var localeData = null;
var DEFAULT_PAYMENT_METHOD_TYPE = "CARD";
var DEFAULT_ALLOWED_CARD_NETWORKS = ["VISA", "MASTERCARD"];
var DEFAULT_CARD_AUTH_METHODS = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
var DEFAULT_TOTAL_PRICE_STATUS = "FINAL";
/** @internal */
var GooglePaySdkImpl = /** @class */ (function () {
    function GooglePaySdkImpl() {
        var _this = this;
        this.initSdk = function (googlePayInitParams) {
            var validationResult = validateGooglePayInitParams(googlePayInitParams);
            if (validationResult.length > 0) {
                eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_ERROR, validationResult.join(", "));
                return;
            }
            eventReporter.initEventReporterService(googlePayInitParams.pspName, googlePayInitParams.transactionId, googlePayInitParams.merchantId);
            googlePayInitParamsGlobal = googlePayInitParams;
            localeData = getValuesFromLocale(googlePayInitParams.locale);
            addGooglePaySdkScript()
                .then(function () {
                var googleEnvironment = googlePayInitParams.environment === "PROD" ? "PRODUCTION" : "TEST";
                paymentsClient = new google.payments.api.PaymentsClient({
                    environment: googleEnvironment,
                    paymentDataCallbacks: {
                        onPaymentAuthorized: onPaymentAuthorizedImpl,
                        onPaymentDataChanged: googlePayInitParams.onPaymentDataChanged ? onPaymentDataChangedImpl : undefined,
                    },
                });
                if (!localeData) {
                    throw new Error("locale is not valid");
                }
                initSdkImpl(googlePayInitParams, localeData.countryCode);
            })
                .catch(function (error) { return eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_ERROR, error); });
        };
        this.renderButton = function (container, googlePayButtonParams) {
            var validationResult = validateGooglePayButtonParams(googlePayButtonParams);
            if (validationResult.length > 0) {
                eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR, validationResult.join(", "));
                return;
            }
            addGooglePaySdkScript()
                .then(function () { return renderButtonImpl(container, googlePayButtonParams); })
                .catch(function (error) { return eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_RENDER_ERROR, error); });
        };
        this.isUserEligibleToMakePayment = function (googlePayIsReadyToPayParams) {
            if (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.existingPaymentMethodRequired) {
                googlePayIsReadyToPayParams.existingPaymentMethodRequired = true;
            }
            return isReadyToPayImpl(googlePayIsReadyToPayParams);
        };
        this.isReadyToPay = function (googlePayIsReadyToPayParams) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, isReadyToPayImpl(googlePayIsReadyToPayParams)];
        }); }); };
        this.startPayment = function () { return startPaymentImpl(); };
        this.getVersion = function () {
            return {
                sdk: BaseEcomSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK,
                version: SDK_VERSION,
                buildType: BUILD_TYPE,
            };
        };
        eventReporter = new EventReporter();
    }
    return GooglePaySdkImpl;
}());
export { GooglePaySdkImpl };
/** @internal */
var onPaymentDataChangedImpl = function (intermediatePaymentData) { return __awaiter(void 0, void 0, void 0, function () {
    var paymentDataRequestUpdate, googlePayPaymentDataRequestUpdate;
    return __generator(this, function (_a) {
        paymentDataRequestUpdate = {};
        if (!googlePayInitParamsGlobal || typeof googlePayInitParamsGlobal.onPaymentDataChanged !== "function")
            return [2 /*return*/, paymentDataRequestUpdate];
        googlePayPaymentDataRequestUpdate = googlePayInitParamsGlobal.onPaymentDataChanged(intermediatePaymentData);
        if (googlePayPaymentDataRequestUpdate) {
            paymentDataRequestUpdate.error = googlePayPaymentDataRequestUpdate.error;
            paymentDataRequestUpdate.newOfferInfo = googlePayPaymentDataRequestUpdate.newOfferInfo;
            paymentDataRequestUpdate.newShippingOptionParameters = googlePayPaymentDataRequestUpdate.newShippingOptionParameters;
            paymentDataRequestUpdate.newTransactionInfo = googlePayPaymentDataRequestUpdate.newTransactionInfo;
        }
        return [2 /*return*/, paymentDataRequestUpdate];
    });
}); };
/** @internal */
var onPaymentAuthorizedImpl = function (paymentData) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, processPayment(paymentData)
                    .then(function () {
                    var paymentAuthorizationResult = {
                        transactionState: "SUCCESS",
                    };
                    return paymentAuthorizationResult;
                })
                    .catch(function (error) {
                    var paymentDataError = {
                        intent: "PAYMENT_AUTHORIZATION",
                        reason: "OTHER_ERROR",
                        message: error,
                    };
                    var paymentAuthorizationResult = {
                        transactionState: "ERROR",
                        error: paymentDataError,
                    };
                    return paymentAuthorizationResult;
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/** @internal */
var renderButtonImpl = function (container, googlePayButtonParams) {
    var buttonContainer = document.getElementById(container);
    if (!buttonContainer) {
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS);
        return;
    }
    var googlePayButtonLanguage = getButtonLang(googlePayButtonParams, localeData, "PAYAIR_GOOGLE_PAY_SDK");
    if (googlePayButtonLanguage === null) {
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_RENDER_ERROR, "googlePayButtonParams.buttonLocale is required when using `renderButton()` without initializing the SDK first");
        return;
    }
    var existingButton = document.querySelector('[aria-label="Google Pay"]');
    if (!existingButton) {
        var buttonOptions = {
            buttonColor: googlePayButtonParams.buttonColor,
            buttonType: googlePayButtonParams.buttonType,
            buttonSizeMode: googlePayButtonParams.buttonSizeMode
                ? googlePayButtonParams.buttonSizeMode
                : GooglePayButtonSizeModeEnumsObj.STATIC,
            buttonLocale: googlePayButtonLanguage,
            allowedPaymentMethods: allowedPaymentMethods,
            onClick: function () { return googlePayButtonOnClick(googlePayButtonParams.buttonOnClick); },
        };
        var renderButtonPaymentsClient = paymentsClient;
        if (!renderButtonPaymentsClient)
            renderButtonPaymentsClient = new google.payments.api.PaymentsClient({
                environment: googlePayButtonParams.environment === "PROD" ? "PRODUCTION" : "TEST",
            });
        var button = renderButtonPaymentsClient.createButton(buttonOptions);
        buttonContainer.appendChild(button);
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_RENDERED);
        return;
    }
    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_NOT_RENDERED_ALREADY_EXISTS);
};
/** @internal */
var startPaymentImpl = function () {
    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_STARTING);
    if (!paymentsClient || !paymentDataRequest) {
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_STARTING_ERROR, GooglePayEventTypeEnumsObj.SDK_NOT_INITIALIZED);
        return;
    }
    paymentsClient.loadPaymentData(paymentDataRequest).catch(function (error) {
        var additionalInfo = error;
        if (error.hasOwnProperty("statusCode")) {
            additionalInfo = error.statusCode;
        }
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_STARTING_ERROR, additionalInfo);
    });
    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_STARTED);
};
/** @internal */
var processPayment = function (paymentData) { return __awaiter(void 0, void 0, void 0, function () {
    var paymentToken, shippingAddress, billingAddress, email;
    var _a;
    return __generator(this, function (_b) {
        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_STARTING);
        paymentToken = paymentData.paymentMethodData.tokenizationData.token;
        shippingAddress = paymentData.shippingAddress;
        billingAddress = (_a = paymentData.paymentMethodData.info) === null || _a === void 0 ? void 0 : _a.billingAddress;
        email = paymentData.email;
        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!googlePayInitParamsGlobal || !googlePayInitParamsGlobal.transactionId) {
                                return [2 /*return*/, reject("TransactionId is not defined")];
                            }
                            return [4 /*yield*/, googlePaySdkService
                                    .completePayment(paymentToken, googlePayInitParamsGlobal.transactionId, shippingAddress, billingAddress, email)
                                    .then(function (response) {
                                    var xRequestId = response.xRequestId;
                                    if (response.responseJson && response.responseJson.status === "APPROVED") {
                                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_OK, undefined, xRequestId);
                                        resolve(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_OK);
                                    }
                                    else if (response.responseJson && response.responseJson.status === "REQUIRED_3DS") {
                                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_REQUIRED_3DS, response.responseJson, xRequestId);
                                        resolve(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_REQUIRED_3DS);
                                    }
                                    else if (!response.responseJson && response.error) {
                                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, response.error, response.xRequestId);
                                        reject(response.error);
                                    }
                                    else {
                                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, response.responseJson, xRequestId);
                                        reject("Payment not approved.");
                                    }
                                })
                                    .catch(function (error) {
                                    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, error, error.xRequestId);
                                    reject(error);
                                })];
                        case 1:
                            _a.sent();
                            eventReporter.sendEvent(GooglePayEventTypeEnumsObj.PAYMENT_COMPLETION_STARTED);
                            return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
/** @internal */
var googlePayButtonOnClick = function (userButtonOnClickFunction) {
    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.BUTTON_CLICK);
    if (userButtonOnClickFunction)
        userButtonOnClickFunction();
    else
        startPaymentImpl();
};
/** @internal */
var getAllowedPaymentMethods = function (googlePayIsReadyToPayParams, billingAddressRequired, billingAddressParameters) {
    var tokenizationSpecification = {
        type: "PAYMENT_GATEWAY",
        parameters: {
            gateway: (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.gateway) ? googlePayIsReadyToPayParams.gateway : "",
            gatewayMerchantId: (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.gatewayMerchantId)
                ? googlePayIsReadyToPayParams.gatewayMerchantId
                : "",
        },
    };
    var allowedCardNetworks = (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.allowedCardNetworks)
        ? googlePayIsReadyToPayParams.allowedCardNetworks
        : DEFAULT_ALLOWED_CARD_NETWORKS;
    var allowedCardAuthMethods = (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.allowedCardAuthMethods)
        ? googlePayIsReadyToPayParams.allowedCardAuthMethods
        : DEFAULT_CARD_AUTH_METHODS;
    var paymentMethodSpecification = {
        type: (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.paymentMethodType)
            ? googlePayIsReadyToPayParams.paymentMethodType
            : DEFAULT_PAYMENT_METHOD_TYPE,
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
            billingAddressRequired: billingAddressRequired,
            billingAddressParameters: billingAddressParameters,
        },
        tokenizationSpecification: tokenizationSpecification,
    };
    return [paymentMethodSpecification];
};
/** @internal */
var isBrowserSupported = function () {
    var browserInfo = detect();
    if (!browserInfo) {
        return false;
    }
    return !notSupportedBrowsers.includes(browserInfo.name);
};
/** @internal */
var isReadyToPayImpl = function (googlePayIsReadyToPayParams) { return __awaiter(void 0, void 0, void 0, function () {
    var addGooglePaySdkScriptPromiseResult, isReadyToPayRequest, isReadyToPayPaymentsClient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isBrowserSupported()) {
                    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.DEVICE_NOT_READY_TO_PAY, "Browser not supported");
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, addGooglePaySdkScript()];
            case 1:
                addGooglePaySdkScriptPromiseResult = _a.sent();
                if (addGooglePaySdkScriptPromiseResult !== true) {
                    return [2 /*return*/, Promise.reject(addGooglePaySdkScriptPromiseResult)];
                }
                isReadyToPayRequest = {
                    apiVersion: apiVersion,
                    apiVersionMinor: apiVersionMinor,
                    allowedPaymentMethods: allowedPaymentMethods
                        ? allowedPaymentMethods
                        : getAllowedPaymentMethods(googlePayIsReadyToPayParams),
                };
                isReadyToPayPaymentsClient = paymentsClient;
                if (!isReadyToPayPaymentsClient) {
                    isReadyToPayPaymentsClient = new google.payments.api.PaymentsClient({
                        environment: (googlePayIsReadyToPayParams === null || googlePayIsReadyToPayParams === void 0 ? void 0 : googlePayIsReadyToPayParams.environment) === "PROD" ? "PRODUCTION" : "TEST",
                    });
                }
                return [4 /*yield*/, isReadyToPayPaymentsClient
                        .isReadyToPay(isReadyToPayRequest)
                        .then(function (response) {
                        if (response.result) {
                            eventReporter.sendEvent(GooglePayEventTypeEnumsObj.DEVICE_READY_TO_PAY);
                            return Promise.resolve(true);
                        }
                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.DEVICE_NOT_READY_TO_PAY);
                        return Promise.resolve(false);
                    })
                        .catch(function (error) {
                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.DEVICE_NOT_READY_TO_PAY, error);
                        return Promise.reject(error);
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/** @internal */
export var addGooglePaySdkScript = function () { return __awaiter(void 0, void 0, void 0, function () {
    var addGooglePaySdkScriptPromise;
    return __generator(this, function (_a) {
        addGooglePaySdkScriptPromise = new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var isScriptAdded, intervalId_1, script;
            return __generator(this, function (_a) {
                isScriptAdded = !!Array.from(document.head.childNodes).filter(function (node) { return node && node["src"] && node["src"].match(new RegExp(GOOGLE_PAY_SDK_SCRIPT)); }).length;
                if (isScriptAdded) {
                    intervalId_1 = setInterval(function () {
                        if (window["googlePayScriptLoaded"] === true) {
                            clearInterval(intervalId_1);
                            resolve(true);
                        }
                    }, 100);
                }
                else {
                    script = document.createElement("script");
                    script.src = GOOGLE_PAY_SDK_SCRIPT;
                    script.async = true;
                    script.onload = function () {
                        window["googlePayScriptLoaded"] = true;
                        resolve(true);
                    };
                    script.onerror = function (error) { return reject(error); };
                    document.head.appendChild(script);
                }
                return [2 /*return*/];
            });
        }); });
        return [2 /*return*/, addGooglePaySdkScriptPromise];
    });
}); };
/** @internal */
var initSdkImpl = function (googlePayInitParams, countryCode) { return __awaiter(void 0, void 0, void 0, function () {
    var merchantInfo, transactionInfo, isReadyToPayRequest, callbackIntents, isGooglePayReadyToPay;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                merchantInfo = {
                    merchantId: googlePayInitParams.merchantId,
                    merchantName: googlePayInitParams.merchantName,
                };
                transactionInfo = {
                    countryCode: countryCode,
                    currencyCode: googlePayInitParams.currencyCode,
                    transactionId: googlePayInitParams.transactionId,
                    totalPrice: googlePayInitParams.totalAmount,
                    totalPriceLabel: googlePayInitParams.totalAmountLabel,
                    totalPriceStatus: googlePayInitParams.totalPriceStatus
                        ? googlePayInitParams.totalPriceStatus
                        : DEFAULT_TOTAL_PRICE_STATUS,
                };
                isReadyToPayRequest = {
                    paymentMethodType: googlePayInitParams.paymentMethodType,
                    allowedCardAuthMethods: googlePayInitParams.allowedCardAuthMethods,
                    allowedCardNetworks: googlePayInitParams.allowedCardNetworks,
                    environment: googlePayInitParams.environment,
                    gateway: googlePayInitParams.gateway ? googlePayInitParams.gateway : googlePayInitParams.pspName,
                    gatewayMerchantId: googlePayInitParams.gatewayMerchantId
                        ? googlePayInitParams.gatewayMerchantId
                        : googlePayInitParams.merchantId,
                };
                allowedPaymentMethods = getAllowedPaymentMethods(isReadyToPayRequest, googlePayInitParams.billingAddressRequired, googlePayInitParams.billingAddressParameters);
                callbackIntents = ["PAYMENT_AUTHORIZATION"];
                if (typeof googlePayInitParams.onPaymentDataChanged === "function") {
                    if (!googlePayInitParams.shippingAddressRequired && !googlePayInitParams.enablePromoCodes) {
                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_ERROR, "shippingAddressParameters or enablePromoCodes must be defined");
                        return [2 /*return*/];
                    }
                    if (!googlePayInitParams.shippingAddressRequired && googlePayInitParams.shippingOptionRequired) {
                        eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_ERROR, "If shippingOptionParameters is defined, shippingAddressParameters must be set");
                        return [2 /*return*/];
                    }
                    if (googlePayInitParams.enablePromoCodes === true)
                        callbackIntents.push("OFFER");
                    if (googlePayInitParams.shippingAddressRequired)
                        callbackIntents.push("SHIPPING_ADDRESS");
                    if (googlePayInitParams.shippingOptionRequired)
                        callbackIntents.push("SHIPPING_OPTION");
                }
                paymentDataRequest = {
                    merchantInfo: merchantInfo,
                    apiVersion: apiVersion,
                    apiVersionMinor: apiVersionMinor,
                    allowedPaymentMethods: allowedPaymentMethods,
                    transactionInfo: transactionInfo,
                    callbackIntents: callbackIntents,
                    shippingAddressRequired: googlePayInitParams.shippingAddressRequired,
                    shippingOptionRequired: googlePayInitParams.shippingOptionRequired,
                    shippingAddressParameters: googlePayInitParams.shippingAddressRequired
                        ? googlePayInitParams.shippingAddressParameters
                        : undefined,
                    shippingOptionParameters: googlePayInitParams.shippingOptionRequired
                        ? googlePayInitParams.shippingOptionParameters
                        : undefined,
                    emailRequired: googlePayInitParams.emailRequired
                };
                return [4 /*yield*/, isReadyToPayImpl()];
            case 1:
                isGooglePayReadyToPay = _a.sent();
                if (isGooglePayReadyToPay) {
                    googlePaySdkService = new GooglePaySdkService(googlePayInitParams.pspName);
                    eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_SUCCESS);
                    return [2 /*return*/];
                }
                eventReporter.sendEvent(GooglePayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_DEVICE_NOT_READY_TO_PAY);
                return [2 /*return*/];
        }
    });
}); };
